'use strict';

var NAV_FIXED = (function (my) {
    var _onResizeTimeout,
        _breakpoint_header,
        $masthead,
        $el_fixed,
        $el_fixed__parent,
        $viewport,
        $footer,
        $gotop,
        $html;

    var _onResize = function () {
        var windowHeight = $(window).height();
        var mastheadHeight = $('.masthead').height();
        var heroHeight = $('.hero__wrap').height();
        var footerHeight = $footer.outerHeight();
        var headerHeight = $('.header_wrap').outerHeight();
        var expandedHeight = windowHeight - headerHeight - footerHeight;
        $('.page-row-expanded').css({'min-height': expandedHeight + 'px'});

        var windowWidth = $(window).width();
        if (windowWidth < _breakpoint_header) {
            $el_fixed__parent.css({'min-height': '0'});
            $el_fixed.removeClass('el_fixed--fixed el_fixed--bottom');

            return;
        }

        var viewportHeight = $('.scrollport').outerHeight();
        $el_fixed__parent.css({'min-height': viewportHeight + 'px'});

        // on scroll
        var fixedElHeight = $el_fixed.height(),
            parentElHeight = $el_fixed__parent.height(),
            paddingBottom = 50,
            scrollTopValue = $(window).scrollTop();

        console.log(parentElHeight - paddingBottom - fixedElHeight );
        console.log(scrollTopValue - mastheadHeight - heroHeight);
        console.log('');

        if ((scrollTopValue - mastheadHeight - heroHeight) < 0) {
            console.log('top');
            $el_fixed
                .removeClass('el_fixed--fixed')
                .removeClass('el_fixed--bottom'); // addClass
        } else if ((parentElHeight - paddingBottom - fixedElHeight ) <= scrollTopValue - mastheadHeight - heroHeight) {
            console.log('middle');
            $el_fixed
                .addClass('el_fixed--bottom')
                .removeClass('el_fixed--fixed');
        } else {
            console.log('bottom');
            $el_fixed
                .removeClass('el_fixed--bottom')
                .addClass('el_fixed--fixed'); // add class

            $el_fixed.css('top', scrollTopValue - mastheadHeight - heroHeight + 'px');
        }
    };

    var _onResizeHandler = function() {
        clearTimeout(_onResizeTimeout);
        _onResizeTimeout = setTimeout(_onResize, 20);
    };

    my.init = function() {
        _breakpoint_header  = 768;

        $html               = $('html');
        $masthead           = $('.masthead');
        $el_fixed           = $('.el_fixed');
        $el_fixed__parent   = $('.el_fixed__parent');
        $viewport           = $('.scrollport');
        $footer             = $('.footer');
        $gotop              = $('.gotop__wrap');

        $(window).on('resize orientationchange', _onResizeHandler); // execute after timeout
        $(window).on('scroll', _onResize); // immediate execution

        _onResize();

        $(document).on('load lazyloaded', function(){
            _onResize();
        });

        // $('body').imagesLoaded(function() {
        //     _onResize();
        // });
    };

    my.onResize = _onResize;

    return my;

}(NAV_FIXED || {}));

$(function() {
    NAV_FIXED.init();
});